import http from './http';

// Endpoint map for the new-theme "continue registration" page.
// Base: /{pathname}/continue-registration/*  (web/session group, token-keyed).
// The signed attendee token identifies who is finishing registration; it is
// threaded through every call.
const base = (pathname) => `/${pathname}/continue-registration`;

const continueAPI = {
  // Bootstrap: event header + identity-locked form schema + sessions availability.
  bootstrap: (pathname, token) => http.get(`${base(pathname)}/data`, { token }),

  // Save the attendee's registration form details.
  updateAttendee: (pathname, data) => http.put(`${base(pathname)}/attendee`, data),

  // Agenda sessions step.
  fetchSessions: (pathname, token) => http.get(`${base(pathname)}/sessions`, { token }),
  updateSessions: (pathname, data) => http.put(`${base(pathname)}/sessions`, data),
};

export default continueAPI;
